module.exports = __webpack_public_path__ + "679490e4a227679eff9c884f12c968e3.png";